import { ComponentPropsWithoutRef } from 'react';
import { Button } from '@givebutter/primitives/button';
import { faBookmark } from '@fortawesome/pro-regular-svg-icons';
import { faBookmark as faBookmarkSolid } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Table from 'components/table';

interface HasSavedTableEmptyProps extends ComponentPropsWithoutRef<'div'> {
    toggleSavedForLater: () => void;
}

const HasSavedTableEmpty = ({ toggleSavedForLater, ...props }: HasSavedTableEmptyProps) => {
    return (
        <Table.Empty {...props}>
            <Table.EmptyIcon>
                <FontAwesomeIcon icon={faBookmarkSolid} />
            </Table.EmptyIcon>
            <Table.EmptyTitle>No issues here</Table.EmptyTitle>
            <Table.EmptyDescription className="flex flex-col gap-6">
                <span>You have saved issues that need to be resolved.</span>
                <Button
                    variant={'outline'}
                    color={'neutral'}
                    className="mx-auto"
                    onClick={e => {
                        e.preventDefault();
                        toggleSavedForLater();
                    }}
                >
                    <FontAwesomeIcon icon={faBookmark} />
                    <span>View saved issues</span>
                </Button>
            </Table.EmptyDescription>
        </Table.Empty>
    );
};

export { HasSavedTableEmpty };
